import { Users, Store, Inbox, UtensilsCrossed, ArrowRight, Loader2 } from "lucide-react";
import { SheetsConnectCard } from "./bits";

const SummaryCard = ({ testId, icon: Icon, label, value, note, onOpen }) => (
  <button onClick={onOpen} data-testid={testId} className="card-dark group p-6 text-left sm:p-8">
    <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#1E3A8A]/40 bg-[#1E3A8A]/10">
      <Icon size={16} className="text-[#1E3A8A]" />
    </span>
    <p className="mt-5 font-sans text-[10px] tracking-[0.25em] text-[#94A3B8]">{label.toUpperCase()}</p>
    <p className="mt-2 font-sans text-4xl text-[#0F172A]" data-testid={`${testId}-value`}>{value}</p>
    {note && <p className="mt-2 text-xs leading-relaxed text-[#94A3B8]">{note}</p>}
    <span className="mt-4 inline-flex items-center gap-1.5 font-sans text-[10px] tracking-[0.2em] text-[#1E3A8A]/70 transition-colors group-hover:text-[#1E3A8A]">
      OPEN <ArrowRight size={12} />
    </span>
  </button>
);

export const DashboardView = ({ summary, onNavigate }) => {
  if (!summary) {
    return (
      <div className="flex justify-center py-16" data-testid="dashboard-loading">
        <Loader2 size={24} className="animate-spin text-[#1E3A8A]" />
      </div>
    );
  }

  const sheetValue = (n) => (summary.sheets_connected ? String(n ?? 0) : "—");
  const sheetNote = summary.sheets_connected ? "Live from your Google Sheets tracker" : "Connect Google Sheets to see live records";

  return (
    <div className="mt-12" data-testid="admin-dashboard">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        <SummaryCard
          testId="summary-buyers"
          icon={Users}
          label="Buyer Waitlist"
          value={sheetValue(summary.buyers)}
          note={sheetNote}
          onOpen={() => onNavigate("buyers")}
        />
        <SummaryCard
          testId="summary-vendors"
          icon={Store}
          label="Vendor Applications"
          value={sheetValue(summary.vendors)}
          note={sheetNote}
          onOpen={() => onNavigate("vendors")}
        />
        <SummaryCard
          testId="summary-enquiries"
          icon={Inbox}
          label="Contact Enquiries"
          value={String(summary.enquiries)}
          note="Saved from the website contact form"
          onOpen={() => onNavigate("enquiries")}
        />
      </div>

      <button
        onClick={() => onNavigate("restaurants")}
        data-testid="summary-restaurants"
        className="card-dark group mt-5 flex w-full flex-wrap items-center justify-between gap-3 p-5 text-left sm:px-8"
      >
        <span className="flex items-center gap-3">
          <UtensilsCrossed size={15} className="text-[#1E3A8A]/70" />
          <span className="font-sans text-[10px] tracking-[0.25em] text-[#94A3B8]">RESTAURANT SIGN-UPS (LEGACY)</span>
        </span>
        <span className="flex items-center gap-2 font-sans text-[11px] tracking-[0.2em] text-[#1E3A8A]/70 transition-colors group-hover:text-[#1E3A8A]">
          <span data-testid="summary-restaurants-value">{summary.restaurant_signups}</span> REVIEW <ArrowRight size={12} />
        </span>
      </button>

      {!summary.sheets_connected && (
        <div className="mt-10">
          <SheetsConnectCard testId="dashboard-sheets-connect" status={{ configured: undefined }} />
        </div>
      )}
    </div>
  );
};
